import React from "react";

const Footer = () => {
  return (
    <div className='mt-24 md:mt-48 pb-12 md:pb-24 flex flex-col md:flex-row gap-6 md:gap-0 md:items-center md:justify-between text-base md:text-2xl font-medium'>
      <p
        className='flex text-dark dark:text-light'
        onClick={(e) => {
          window.open(
            "https://twitter.com/adebisi_ui?s=20&t=LWUmpGfNVnhE__6OivDtrQ",
            "_blank",
          );
        }}
      >
        Design By :&nbsp;
        <p className='talk-heading relative'>
          <div className='button-underline-div bg-dark dark:bg-light'></div>
          adebisi
        </p>
      </p>

      <a
        className='text-base md:text-2xl font-medium relative talk-heading text-dark dark:text-light w-fit'
        href='mailto:mominnaveed1997@gmail.com?subject=Lets%20work%20together!&amp;body=Hello%2C%20I%20think%20we%20need%20you%20to%20work%20on%2Fcollaborate%20this%20particular%20product...%20Reach%20out%20as%20soon%20as%20you%20can.'
      >
        <div className='button-underline-div bg-dark dark:bg-light cursor-pointer'></div>
        Contact me by mail!
      </a>
    </div>
  );
};

export default Footer;
